import React from "react";

import DeliveryCourierEarnings from "./DeliveryCourierEarnings";

export default function DeliveryEarnings() {
  return <DeliveryCourierEarnings />;
}
